import { IntroIFrame, IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';
import styles from '../_intro.module.scss';

const AudioTrack1 = () => (
  <IntroWrapper>
    <p>
      Welcome to the <b>Music Track</b>! This shows the waveform of your selected music.
    </p>
  </IntroWrapper>
);

const AudioTrack2 = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Zoom: </b>You can zoom in and out of the waveform using your <b>mouse wheel</b> or <b>touch pad</b>, just like
      with the Storyboard Track.
    </p>
    <p>
      <i>Give it a try!</i>
    </p>
    <IntroIFrame src="https://www.youtube.com/embed/ZhCz-D6dvr8" />
  </IntroWrapper>
);

const AudioTrack3 = () => (
  <IntroWrapper>
    <p>
      While you can't edit the audio directly in Pulse, you can define the active storyboard segment with the start and
      end storyboard markers.
    </p>
  </IntroWrapper>
);

const StartRangeMarker = () => (
  <IntroWrapper>
    <p>
      This is the <b>Start Range Marker</b>. It defines the beginning of the active storyboard segment.
    </p>
    <p>
      You can drag this marker to adjust where your storyboard begins. Only clips within the range between the start and
      end markers will be included in your final montage.
    </p>
  </IntroWrapper>
);

const EndRangeMarker = () => (
  <IntroWrapper>
    <p>
      This is the <b>End Range Marker</b>. It defines the end of the active storyboard segment.
    </p>
    <p>
      You can drag this marker to adjust where your storyboard ends. Only clips within the range between the start and
      end markers will be included in your final montage.
    </p>
  </IntroWrapper>
);

const AudioTrack4 = () => (
  <IntroWrapper size="medium">
    <p>
      The vertical lines are <b>beat markers</b>. Pulse automatically places beat markers at the "down beats" of your
      music. They are the foundation for your montage's timing.
    </p>
  </IntroWrapper>
);

const FirstBeatMarker = () => (
  <IntroWrapper size="medium">
    <p>
      This is a <b>beat marker</b> (embedded in a clip transition).
    </p>
    <p>
      Beat markers automatically determine the duration of each clip on the Storyboard Track below, ensuring your video
      is synchronized to the music.
    </p>
  </IntroWrapper>
);

const LengthenCell = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Tip:</b> For the best results, we recommend keeping the default beat marker positions to ensure your montage
      stays perfectly synchronized with the music.
    </p>
    <p>If you do need to make adjustments, you can do so by adding, removing, or moving beat markers.</p>
    <p>For example, to lengthen the duration of a cell follow the steps in this video:</p>
    <ul>
      <li>00:06 - press and hold the ctrl-key</li>
      <li>00:08 - click the beat marker at the end of your clip</li>
      <li>00:09 - press the delete key</li>
      <li>
        00:09 - note that the beat marker has been removed and that your clip length is now lengthed by the duration of
        the next beat cell
      </li>
    </ul>
    <IntroIFrame src="https://youtube.com/embed/e6gvxtSEOjg" />
  </IntroWrapper>
);

export const TUTS_AUDIO_TRACK = [
  { element: `[data-intro="${IntroKeys.sbAudioHeader}"]`, intro: <AudioTrack1 /> },
  { element: `[data-intro="${IntroKeys.sbAudioHeader}"]`, intro: <AudioTrack2 /> },
  { element: `[data-intro="${IntroKeys.sbAudioHeader}"]`, intro: <AudioTrack3 /> },
  { element: `[data-intro="${IntroKeys.startRangeMarker}"]`, intro: <StartRangeMarker /> },
  { element: `[data-intro="${IntroKeys.endRangeMarker}"]`, intro: <EndRangeMarker /> },
  { element: `[data-intro="${IntroKeys.sbAudioHeader}"]`, intro: <AudioTrack4 /> },
  { element: `[data-intro="${IntroKeys.firstBeatMarker}"]`, intro: <FirstBeatMarker /> },
  {
    element: `[data-intro="${IntroKeys.firstBeatMarker}"]`,
    intro: <LengthenCell />,
    name: 'lengthenCell',
    tooltipClass: styles.LengthenCell,
    position: 'right',
  },
];
